import Stage from 'components/Designer/Stage'
import Island from '../Components/Island'

class Perforation {
  private static _tex: HTMLCanvasElement
  private static _tex2: HTMLCanvasElement
  private _enabled: boolean = false
  private _radius: number = 0.3 // NOTE: in mm
  private _distance: number = 1 // NOTE: in cm
  private _island: Island

  constructor(island: Island) {
    this._island = island
    if (!Perforation._tex) {
      const canvas = document.createElement('CANVAS') as HTMLCanvasElement
      const res = 128
      canvas.width = canvas.height = res
      Perforation._tex = canvas

      const canvas2 = document.createElement('CANVAS') as HTMLCanvasElement
      canvas2.width = canvas2.height = res
      Perforation._tex2 = canvas2

      document.body.appendChild(canvas)
      document.body.appendChild(canvas2)
      const ctx = canvas.getContext('2d')!

      ctx.fillStyle = 'transparent'
      ctx.fillRect(0, 0, res, res)

      const grad = ctx.createRadialGradient(
        res / 2,
        res / 2,
        res / 8,
        res / 2,
        res / 2,
        res / 2
      )
      for (let i = 1; i > 0.01; i = i / 2) {
        grad.addColorStop(i, `rgba(0,0,0,${1 - i})`)
      }
      grad.addColorStop(0, `rgba(0,0,0,1)`)
      ctx.fillStyle = grad
      ctx.fillRect(0, 0, res, res)

      const crop = 1
      const Im = ctx.getImageData(0, 0, res / crop, res / crop)
      const ImD = Im.data
      const exp = 6
      for (var i = 0; i < ImD.length; i += 4) {
        let alpha = Math.pow(ImD[i + 3] / 255, exp)
        alpha = Math.min(Math.max(alpha, 0), 1)
        const noise = Math.random() * (1 - alpha) * 8
        alpha = Math.min(Math.max(alpha * 255 - noise, 0), 255)
        ImD[i + 3] = Math.round(alpha)
      }
      ctx.putImageData(Im, 0, 0)

      const ctx2 = canvas2.getContext('2d')!
      ctx2.fillStyle = 'transparent'
      ctx2.fillRect(0, 0, res, res)

      const grad2 = ctx.createRadialGradient(
        res / 2,
        res / 2,
        1,
        res / 2,
        res / 2,
        res / 2
      )
      for (let i = 1; i > 0.01; i = i / 2) {
        grad2.addColorStop(i, `rgba(0,0,0,${1 - i})`)
      }
      grad2.addColorStop(0, `rgba(0,0,0,1)`)
      ctx2.fillStyle = grad2
      ctx2.fillRect(0, 0, res, res)

      const Im2 = ctx2.getImageData(0, 0, res / crop, res / crop)
      const ImD2 = Im2.data
      const exp2 = 6
      for (let i = 0; i < ImD2.length; i += 4) {
        let alpha = Math.pow(ImD2[i + 3] / 255, exp2)
        alpha = Math.min(Math.max(alpha, 0), 1)
        const noise = Math.random() * (1 - alpha) * 8
        alpha = Math.min(Math.max(alpha * 255 - noise, 0), 255)
        ImD2[i + 3] = Math.round(alpha / 16)
      }
      ctx2.putImageData(Im2, 0, 0)
    }
  }

  public get enabled() {
    return this._enabled
  }

  public enable(): void {
    this._enabled = true
  }

  public disable(): void {
    this._enabled = false
  }

  public set radius(r: number) {
    this._radius = r
  }

  public set distance(d: number) {
    this._distance = d
  }

  public get radius() {
    return this._radius
  }

  public get distance() {
    return this._distance
  }

  public get size(): number {
    return Perforation._tex.width
  }

  public static set radius(r: number) {
    for (const island of Stage.selection) {
      island.perforation.enable()
      island.perforation.radius = r
      island.refresh()
    }
  }

  public static set distance(d: number) {
    for (const island of Stage.selection) {
      island.perforation.enable()
      island.perforation.distance = d
      island.refresh()
    }
  }

  public get texture() {
    return Perforation._tex
  }

  public get texture2() {
    return Perforation._tex2
  }
}

export default Perforation
